import { DetailedHTMLProps, forwardRef, HTMLAttributes } from 'react';

import styles from './Menu.module.scss';

export type MenuProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    parentId?: string;
};

export const Menu = forwardRef<HTMLDivElement, MenuProps>(function Menu(
    { className, ...props }: MenuProps,
    ref,
) {
    return <div {...props} className={`${styles.menu} ${className || ''}`} ref={ref} />;
});
